module.exports = __webpack_public_path__ + "img/element-right.8e42c1f7.png";